`<template>
  <div class="home">

    <ZPInfo/>

    <div class="user">
      <UserInfo :info="{'userInfo':{'nickname':true,'avatar':true}}" />
    </div>

    <div class="friends">
      <Friends/>
    </div>
    
    <div class="rank">
      <Rank/>
    </div>


    <div class="videos_wrap">
      <img class="title" src="https://vipcdn.mgtv.com/upload3/201810/20181025/zp2018/video_title2.png" alt="">
      <ActVideosRecommend :info="{'actVideosRecommend': {
      style: {
      color:'white',
      padding:'0 0.4rem'
      },
      'disable_click': false, //默认是false 是否可以点击
      'hide_title':true,
      'hide_name':false
      }}"></ActVideosRecommend>
    </div>



    <div class="privilege">
      <img src="https://vipcdn.mgtv.com/upload3/201810/20181025/zp2018/priviledge2.png" class="title" alt="">
    </div>

    <div class="ruler">
      <img src="https://vipcdn.mgtv.com/upload3/201810/20181025/zp2018/ruler_title.png" class="title" alt="">
      <p v-for="item in ruler">{{item}}</p>
    </div>



  </div>

</template>

<script>

  import setTitle from '../tools/set-title'
  import {page_view, casherPV} from '../tools/mgtv/analysis'
  import {setShare} from '../tools/mgtv/share'
  import Vue from 'vue';

  import preload from '../tools/preload'

  import UserInfo from '../components/ConfigUI/UserInfo.vue'
  // import Ship from '../components/ConfigUI/Ship.vue'

  // import HotSpot from '../components/ConfigUI/HotSpot.vue'
  import ActVideo from '../components/ConfigUI/ActVideo.vue'
  // import AppDownload from '../components/ConfigUI/AppDownload.vue'
  // import ActImg from '../components/ConfigUI/ActImg.vue'
  // import ChannelChooser from '../components/Popups/ChannelChooser.vue'
  // import ActText from '../components/ConfigUI/ActText.vue'
  // import ActYuyueBtn from '../components/ConfigUI/ActYuyueBtn.vue'
  import ActVideosRecommend from '../components/ConfigUI/ActVideosRecommend.vue'
  import get_open_id from '../tools/mgtv/openid'
  // import NineLottery from '../components/ConfigUI/Lottery/NineLottery.vue'
  // import LotteryRemainTimes from '../components/ConfigUI/Lottery/LotteryRemainTimes.vue'
  // import ScratcherLottery from '../components/ConfigUI/Lottery/ScratcherLottery.vue'


  //  import ActSwipe from '../components/ConfigUI/ActSwipe.vue'
  import ZPInfo from '../components/ZPInfo.vue'
  import Friends from '../components/Friends.vue'
  import Rank from '../components/Rank.vue'


  import {PAGE_CREATE,GET_ZP_RANK} from '../constant/eventbus'
  import '../components/Popups/Dialog'
  import '../components/Popups/Toast'
  // import  '../components/Popups/HtmlDialog/index'
  import '../components/Popups/ShareDialog/index'
  // import  '../components/Popups/SubmitDialog/index'
  import '../components/Popups/ActAlertDialog/index'
  import '../components/Popups/CaptchaDialog/index'
  // import  '../components/Popups/LotteryHistoryDialog/index'
  import click_handler from '../tools/mgtv/click'
  import to_cashier from '../tools/mgtv/casher'
   import {HOME_PAGE} from '../constant/analysis'

  export default {
    name: 'HomePage',
    components: {
      ZPInfo,
      UserInfo,
      ActVideosRecommend,
      Friends,
      Rank
    },
    created() {
      window.$bus.$emit(GET_ZP_RANK);
    },
    mounted() {
      setTimeout(() => {
        page_view(HOME_PAGE);
      }, 1000);
    },
    computed: {
      ruler(){
        const ruler_str = window.$bus.ext.ruler;
        if(ruler_str){
          return ruler_str.split(/\\n|<br>|<br\/>/);
        }else{
          return []
        }
      },
      act(){
        return window.rootdata.act
      }
    },
    methods: {

    }
  }
</script>
<!--
-->
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">

  @import "../share/mixins.styl"
  .home
    width: 7.5rem;
    position relative;
    display block;
    overflow hidden
    background #160a29
    min-height 100vh
    padding-bottom .8rem
    .user
      position absolute
      top .1rem
      right .1rem
    .friends
      position relative
    .act
      position relative
      display block
      width 7.5rem
      margin .1rem 0
      img
        width @width
    .rank
      position relative
    .videos_wrap
      padding-top .2rem
      position relative
      background #211435
      >.title
        margin 0 auto
        display block
        width 2.86rem
        padding-bottom .2rem

    .privilege
      margin .2rem
      padding-top .2rem
      position relative
      background #211435
      img
        width 100%
    .ruler
      margin .2rem
      padding .2rem
      position relative
      background #211435
      p
        color white
        font-size .26rem
        margin-bottom .1rem
      >.title
        margin 0 auto
        display block
        width 2.26rem
        padding-bottom .2rem



</style>
`



// WEBPACK FOOTER //
// src/container/HomePage.vue